import React, { Component } from "react";
import {
  Form,
  Button,
  Alert,
  ButtonToolbar,
  FormGroup,
  FormControl,
  HelpBlock,
  ControlLabel
} from "react-bootstrap";
import { connect } from "react-redux";
import { DckActionCreators, DckSelectors } from "dck-redux";

import * as ItemTypes from "../../redux/items/types";
import ProcessTypes from "../../redux/processes/types";
import apiServerConstants from "../../redux/sagas/apiServerConstants";
import CustomPageHeader from "../fragments/CustomPageHeader";
import Authenticated from "../../lib/Authenticated";

const inputId = "updateInput";

class Update extends Component {

  state = {
    file: null
  };

  valid() {
    return this.state.file != null;
  }

  createUpdateClicked(data) {
    this.props.createUpdate(data);
  }

  componentDidMount() {
    this.props.loadUpdates();
  }

  renderUpdates(updates) {

    if(!updates.length) {
      return <p>No updates were found!</p>;
    }
    else {
      let list = [];
      for (let index = 0; index < updates.length; index++) {
        const element = updates[index];
        list.push(<li key={index}>
          <a href={`${apiServerConstants.host}/updates/apk/${element.id}`} target="_blank">
            { element.fileName }
          </a> - <span>v{`${element.version}`}</span>
        </li>);
      }
      return list;
    }
  }

  renderUploadForm = () => {
    return (
      <div>

        <div className="item-form">
          <Form>
            <FormGroup>
              <ControlLabel>APK file</ControlLabel>
              <FormControl
                id={ inputId }
                type="file"
                accept=".apk"
                onChange={e => this.setState({ file: e.target.files[0] })}
              />
              <HelpBlock>Choose an APK</HelpBlock>
            </FormGroup>
            <br />
          </Form>
        </div>

        { this.props.updateCreating && (
          <Alert bsStyle="info" bsClass="external-page-alert alert">
            <strong>Uploading...</strong>
            <br />
          </Alert>
        )}

        { this.props.updateCreateFailed && (
          <Alert bsStyle="warning" bsClass="external-page-alert alert">
            <strong>Operation failed!</strong>
            <br />
            { this.props.updateCreateProcess.result.message }
          </Alert>
        )}

        { this.props.updateCreatedSuccess && (
          <Alert bsStyle="success" bsClass="external-page-alert alert">
            <strong>Operation success!</strong>
            <br />
            Update created
          </Alert>
        )}

        <ButtonToolbar>
          <Button
            bsStyle="primary"
            onClick={() => this.createUpdateClicked(inputId)}
            disabled={
              !this.valid() ||
              this.props.updateCreateFailed ||
              this.props.updateCreating
            }>
            Upload update
          </Button>
        </ButtonToolbar>

      </div>
    )
  }

  render() {

    const authenticated = new Authenticated();

    return (
      <div>
        <CustomPageHeader icon='cloud-upload' text='Update' />

        { authenticated.isSuper() ? this.renderUploadForm() : null }

        <div>
          <h3>List of available updates</h3>
          {this.props.updates && (
            <div>
              { this.renderUpdates(this.props.updates) }
            </div>
          )}
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  const mapping = {
    updateCreatedSuccess: DckSelectors.selectProcessSuccess(
      state,
      ProcessTypes.UPLOAD_UPDATE
    ),
    updateCreating: DckSelectors.selectProcessRunning(
      state,
      ProcessTypes.UPLOAD_UPDATE
    ),
    updateCreateFailed: DckSelectors.selectProcessFailed(
      state,
      ProcessTypes.UPLOAD_UPDATE
    ),
    updateCreateProcess: DckSelectors.selectProcess(
      state,
      ProcessTypes.UPLOAD_UPDATE
    ),
    updates: DckSelectors.selectAllItems(state, ItemTypes.Update)
  };

  return mapping;
};

const mapDispatchToProps = dispatch => {
  return {
    createUpdate: data => {
      dispatch(DckActionCreators.itemAdd(ItemTypes.Update, data));
    },
    loadUpdates: () =>
      dispatch(DckActionCreators.itemsLoad(ItemTypes.Update)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Update);



// WEBPACK FOOTER //
// ./src/components/Update/index.js